import React from 'react';
import KeyStore from 'utils/KeyStore';
import Permission from 'utils/enum/Permissions';
import TuneOutlinedIcon from '@material-ui/icons/TuneOutlined';
import DevicesIcon from '@material-ui/icons/Devices';
import SettingsInputComponentOutlinedIcon from '@material-ui/icons/SettingsInputComponentOutlined';
import TabSetting from 'components/modules/settings/TabSetting';
import GeneralSetting from 'components/modules/settings/user/GeneralSetting';
import TrustedDevicesSetting from 'components/modules/settings/user/TrustedDevicesSetting';
import Preferences from 'components/modules/settings/personalization/Preferences';

const keyStore = new KeyStore();
const getSettings = () => {
    const settings = [];

    if (keyStore.hasPermission(Permission.USER_EMAIL_SIGNATURE_READ)) {
        settings.push(
            {
                text: 'Email signature',
                icon: <TuneOutlinedIcon />,
                url: 'email-signature',
                component: <GeneralSetting />,
            },
        );
    }

    if (keyStore.hasPermission(Permission.CORE_USER_READ)) {
        settings.push(
            {
                text: 'Trusted devices',
                icon: <DevicesIcon />,
                url: 'trusted-devices',
                component: <TrustedDevicesSetting />,
            },
        );

        settings.push(
            {
                text: 'Preferences',
                icon: <SettingsInputComponentOutlinedIcon />,
                url: 'preferences',
                component: <Preferences />,
            },
        );
    }

    return settings;
};

const UserTabSetting = () => {
    const settings = getSettings();

    return <TabSetting records={settings} />;
};

export default UserTabSetting;
